import React from 'react';
import ReactDOM from 'react-dom';
import { forIn, defaults } from 'lodash';
import AntdZhCN from 'antd/es/locale/zh_CN';

import { builder } from '@comall-backend-builder/core';
import * as defaultComponents from '@comall-backend-builder/components-basis';
import { defaultTypes } from '@comall-backend-builder/types';
import { ErrorInfo } from '@comall-backend-builder/core/lib/services/error-handle';

import * as myConfigs from './config';
import * as myComponents from './components';
import * as myContainers from './containers';
import myLoaders from './loaders';
import myTypes from './type';
import { errorHandle } from './services';

import { zhCN } from './language/zh-CN';

import './design/index';

import './services/api';

import './styles/index.less';
console.log('%cversion->2', 'background:green; color:#fff');
// Initialize global settings
builder.init({
    'api.token': 'demo-api-token',
    'features.i18n': true,
    'features.withCredentials': true,
});

// Customized singleton instance
// services.localStorage.prefix = 'backend-builder-3.0-pzg-';
// services.localStorage.token = 'pzgz-api-token';

// Register components
forIn(defaults(defaultComponents, myComponents, myContainers), (component, name) => {
    builder.registerComponent(name, component);
});

// Register types
defaultTypes.forEach((type, name) => {
    builder.registerType(name, type);
});

myTypes.forEach((type, name) => {
    builder.registerType(name, type);
});

// Register loader
myLoaders.forEach((loader, path) => {
    builder.registerLoader(path, loader);
});

// Register Config
forIn(myConfigs, (config) => {
    builder.registerConfig(config);
});

// Register languages
builder.registerLanguage({
    id: 'zh-CN',
    name: '简体中文',
    context: zhCN,
    antdLocale: AntdZhCN,
});

builder.replaceErrorHandle((error: ErrorInfo) => {
    errorHandle(error);
});
ReactDOM.render(builder.bootstrap(defaultComponents.AntdEntry), document.getElementById('app'));
